import React, { useState } from "react";

import { isProduct, ProductId } from "multitenancy";

import ArrowDown from "../../../../assets/svg/arrow-down.svg";
import ArrowUp from "../../../../assets/svg/arrow-up.svg";
import { IProfile } from "../../interface";
import * as S from "../../styles";

const ModalLevels: React.FC<{
  item: IProfile;
  selected: any | null;
  handleSelectProfile: (profile: any) => void;
  setShowSelector: (profile: boolean) => void;
}> = ({ handleSelectProfile, item, selected, setShowSelector }) => {
  const [showSecondLevel, setShowSecondLevel] = useState(false);
  const noLinkedPlaceMessage = isProduct(ProductId.Inquerito)
    ? "Nenhuma unidade policial atrelada a essa circunscrição"
    : "Nenhuma vara atrelada a essa comarca";

  return (
    <S.ListLevelOne
      key={item.id}
      selected={selected?.id === item?.id}
      isSelectable={!(item?.places && item?.places?.length)}
    >
      <S.ContainerTitle
        onClick={
          item.profile.toLowerCase() !== "master"
            ? () => setShowSecondLevel(!showSecondLevel)
            : () => {
                handleSelectProfile({
                  ...item?.places[0],
                  profileName: item.profile,
                  placeId: item?.places[0].id,
                  title: item?.places[0]?.name,
                  profileId: item.profileId,
                  containerName: item.containerName,
                  profileUniqueId: item.id,
                  profileType: item.profileType,
                });
                setShowSelector(false);
              }
        }
      >
        <span>{`${item?.place} - ${item?.profile}`}</span>
        {item.profile.toLowerCase() !== "master" && (
          <div>
            <img
              className="icon"
              src={showSecondLevel ? ArrowUp : ArrowDown}
              style={{ cursor: "pointer" }}
              alt=""
            />
          </div>
        )}
      </S.ContainerTitle>
      {showSecondLevel &&
        (item?.places && item.places.length > 0 ? (
          item.places.map((itemPlace) => (
            <S.ListLevelTwo
              selected={
                selected?.id === itemPlace?.id &&
                selected?.profileUniqueId === item.id
              }
              key={itemPlace.id}
              onClick={() => {
                handleSelectProfile({
                  ...itemPlace,
                  profileName: item.profile,
                  placeId: itemPlace.id,
                  title: itemPlace.name,
                  profileId: item.profileId,
                  containerName: item.containerName,
                  profileUniqueId: item.id,
                  profileType: item.profileType,
                  confidentialityLevel: item.confidentialityLevel,
                });
                setShowSelector(false);
              }}
            >
              {itemPlace.name}
            </S.ListLevelTwo>
          ))
        ) : (
          <S.ListLevelTwo selected={false} className="placeholder">
            {noLinkedPlaceMessage}
          </S.ListLevelTwo>
        ))}
    </S.ListLevelOne>
  );
};
export default ModalLevels;
